interface TimesIconProps {
    color?: string;
    className?: string;
}

// The multiplication sign of a playback rate, drawn so it centers with the digits
function TimesIcon({ color = 'currentColor', className }: TimesIconProps) {
    return (
        <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d="M2 2l6 6M8 2L2 8" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    );
}

export default TimesIcon;
